import React, { useState, useRef } from 'react';
import html2canvas from 'html2canvas';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { ModalComponent } from '../../../../widgets';
import { Button, Grid, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import { GREEN_COLOR } from '../../../../constants/ColorsConst';
import { useNotification } from '../../../../helpers/Notification';

const ScreenCaptureComponent = ({ children }) => {
  const { notify } = useNotification();

  const cropperRef = useRef(null);
  // const [cropData, setCropData] = useState({ x: 0, y: 0, width: 200, height: 150 }); // Coordenadas iniciales

  const onCrop = () => {
    if (cropperRef.current) {
      // Obtén las coordenadas de recorte desde Cropper
      const cropper = cropperRef.current?.cropper;

      const croppedDataURL = cropper.getCroppedCanvas().toDataURL('image.png');

      // Puedes mostrar la imagen o guardarla como quieras
      // const imagenRecortada = new Image();
      // imagenRecortada.src = croppedDataURL;
      // document.body.appendChild(imagenRecortada);

      // Opcional: Descargar la imagen
      const enlaceDescarga = document.createElement('a');
      enlaceDescarga.href = croppedDataURL;
      enlaceDescarga.download = 'horario.png';

      // Simula el clic para iniciar la descarga
      enlaceDescarga.style.display = 'none'; // Oculta el enlace
      document.body.appendChild(enlaceDescarga);
      enlaceDescarga.click();

      notify('Descarga de la imagén completada.', { info: true });

      // Elimina el enlace después de la descarga
      document.body.removeChild(enlaceDescarga);
    }
  };

  const [imagePreview, setImagePreview] = useState(null);

  const onCropMove = () => {
    if (cropperRef.current) {
      const cropper = cropperRef.current?.cropper;
      const croppedDataURL = cropper.getCroppedCanvas().toDataURL('image.png');
      setImagePreview(croppedDataURL);
    }
  };

  const [capturedImage, setCapturedImage] = useState(null);
  const captureRef = useRef(null);

  const handleCapture = async () => {
    const captureNode = captureRef.current;

    if (captureNode) {
      const canvas = await html2canvas(captureNode, {
        width: captureNode.offsetWidth,
        height: captureNode.offsetHeight,
        x: 0,
        y: 0,
      });

      const imageURL = canvas.toDataURL('image/png');
      setCapturedImage(imageURL);
    }
  };

  // const compartirPorWhatsApp = () => {
  //     if (imagePreview) {
  //       const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(
  //         "Horario"
  //       )}&image=${encodeURIComponent(imagePreview)}`;
  //       window.open(url, '_blank');
  //     }
  //   };

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <Button
        size="small"
        sx={{
          mb: 1,
          backgroundColor: GREEN_COLOR,
        }}
        startIcon={<AspectRatioIcon />}
        variant="contained"
        onClick={handleCapture}
      >
        Capturar imagén y recortar
      </Button>
      {/* <button onClick={handleCapture}>Capturar imagen</button> */}
      <div
        ref={captureRef}
        style={{
          border: '1px dashed #000',
          position: 'relative',
        }}
      >
        {children}
      </div>

      <ModalComponent
        id="modalFormCapture"
        title={`Editar imagén del horario`}
        open={capturedImage}
        maxWidth="full"
        onClose={() => setCapturedImage(null)}
      >
        <Grid container spacing={1}>
          <Grid item md={3}>
            {!imagePreview ? null : (
              <Grid container spacing={1}>
                <Grid item md={12}>
                  <Typography variant="body1" color="initial" sx={{ mt: 2 }}>
                    Vista previa
                  </Typography>
                  <img src={imagePreview} width="100%" alt="Vista Previa" />
                </Grid>
                <Grid item md={12}>
                  <Button
                    size="small"
                    startIcon={<DownloadIcon />}
                    variant="contained"
                    onClick={onCrop}
                  >
                    Descargar imagén
                  </Button>
                </Grid>
                {/* <Grid item md={12}>
                                <Button
                                    size='small'
                                    color="success"
                                    startIcon={<WhatsAppIcon />}
                                    endIcon={<SendIcon />}
                                    variant='contained' onClick={compartirPorWhatsApp}>Enviar por Whatsapp</Button>
                            </Grid> */}
              </Grid>
            )}
          </Grid>
          <Grid item md={9}>
            <Cropper
              ref={cropperRef}
              src={capturedImage} // Reemplaza con la URL o el recurso de imagen que deseas recortar
              // crop={cropData}
              // zoomTo={1}
              // aspectRatio={16 / 9} // Puedes ajustar el aspectRatio según tus necesidades
              // guides={true}
              viewMode={1}
              dragMode="move"
              // minCropBoxWidth={50}
              // minCropBoxHeight={30}
              onCrop={() => {}}
              cropmove={onCropMove}
              // cropmove={() => { alert('move')}}
            />
          </Grid>
        </Grid>
      </ModalComponent>
    </div>
  );
};

export default ScreenCaptureComponent;
